export default __webpack_public_path__ + "static/media/search_background.214a8665.png";